/**
 * Investment question definitions for the AI Scanner (STORY-009).
 *
 * Mirrors the `HASHTAG_DEFINITIONS` convention in `views/scan/HashtagChips.js`:
 * identifiers and localization keys only, no on-screen text.
 *
 * `code` is the internal value captured into `state.scans.aiScannerAnswers` and
 * handed to the scoring step (STORY-010). The `A. ` / `B. ` / `C. ` prefix the
 * user sees is part of the localized label string per the Figma design — it is
 * deliberately NOT derived from `code`, so the two can diverge without breaking
 * the captured value.
 */
const INVESTMENT_QUESTIONS = Object.freeze([
  Object.freeze({
    id: 'q1',
    promptKey: 'ai.scanner.questions.q1.prompt',
    options: Object.freeze([
      Object.freeze({ code: 'A', labelKey: 'ai.scanner.questions.q1.option.a' }),
      Object.freeze({ code: 'B', labelKey: 'ai.scanner.questions.q1.option.b' }),
      Object.freeze({ code: 'C', labelKey: 'ai.scanner.questions.q1.option.c' })
    ])
  }),
  Object.freeze({
    id: 'q2',
    promptKey: 'ai.scanner.questions.q2.prompt',
    cautionKey: 'ai.scanner.questions.q2.caution',
    options: Object.freeze([
      Object.freeze({ code: 'A', labelKey: 'ai.scanner.questions.q2.option.a' }),
      Object.freeze({ code: 'B', labelKey: 'ai.scanner.questions.q2.option.b' }),
      Object.freeze({ code: 'C', labelKey: 'ai.scanner.questions.q2.option.c' })
    ])
  })
]);

export default INVESTMENT_QUESTIONS;
